import { ReactNode } from 'react';
import { Upload } from 'antd';
import { UploadChangeParam, UploadFile } from 'antd/es/upload';
import APIClient from '../../api/api';

const { Dragger } = Upload;

interface UploadDropzoneProps {
  action: string;
  name?: string;
  multiple?: boolean;
  accept?: string;
  disabled?: boolean;
  onChange?: (info: UploadChangeParam<UploadFile<any>>) => void;
  onDrop?: () => void;
  /** Main label (e.g. "Drop a file here"). */
  label?: string;
  /** Secondary hint below the label. */
  hint?: ReactNode;
}

/** Compact themed file-upload dropzone. Wraps antd's Dragger with our palette. */
export function UploadDropzone({
  action,
  name = 'file',
  multiple = false,
  accept,
  disabled,
  onChange,
  onDrop,
  label = 'Drop a file here',
  hint = 'or click to browse',
}: UploadDropzoneProps) {
  return (
    <div className="themed-dropzone w-full max-w-[440px]">
      <Dragger
        action={action}
        name={name}
        multiple={multiple}
        accept={accept}
        disabled={disabled}
        onChange={onChange}
        onDrop={onDrop}
        showUploadList={false}
        headers={APIClient.getAuthHeaders()}
      >
        <div className="flex items-center justify-center gap-3">
          <div className="w-[34px] h-[34px] rounded-md bg-bg-elevated border border-border flex items-center justify-center text-text-2 text-[16px] flex-shrink-0">
            ↑
          </div>
          <div className="flex flex-col text-left">
            <div className="text-text text-[13px] font-medium leading-tight">{label}</div>
            <div className="text-text-3 text-[11.5px] leading-tight mt-0.5">{hint}</div>
          </div>
        </div>
      </Dragger>
    </div>
  );
}
